export default "__VITE_ASSET__TFJrgN9e__"